import { useEffect, useState } from "react";

const useDelayedLoading = (loading: boolean, timeoutMs: number) => {
  const [localIsLoading, setLocalIsLoading] = useState(loading);

  useEffect(() => {
    let clearLoadingTimeout: NodeJS.Timeout;
    if (loading && !localIsLoading) {
      setLocalIsLoading(true);
    } else if (!loading && localIsLoading) {
      clearLoadingTimeout = setTimeout(() => {
        setLocalIsLoading(false);
      }, timeoutMs);
    }
    return () => {
      if (clearLoadingTimeout) {
        clearTimeout(clearLoadingTimeout);
      }
    };
  }, [loading, localIsLoading]);

  return loading || localIsLoading;
};

export default useDelayedLoading;
